let Base64 = require('js-base64').Base64
import {getCodeChallenge, loginByCodeInapp} from '@/api/thirdLogin'
import { isIOS } from '@/assets/js/judgeEnv'
// 一嗨对接文件

// 调用一嗨app登录
function loginByApp() {
  console.log('一嗨app中开始调用原生方法去登陆')
  getCodeChallenge().then(res => {
    if (res.code == 0) {
      let redirectUri = 'https://app.rv2go.com/gateway/activity/v2/autoLoginAndRedirectYH'
      switch(window.env) {
        case 'sit':
        case 'dev': 
          redirectUri = 'https://apptest.rv2go.cn/gateway/activity/v2/autoLoginAndRedirectYH'
          break
        case 'uat':
          redirectUri = 'https://apptest-uat.rv2go.cn/gateway/activity/v2/autoLoginAndRedirectYH'
          break
      }
      let state = `${window.location.href},${res.data}`
      if (isIOS) {
        console.log('一嗨ios登陆方法', window.webkit.messageHandlers.homeCarAuthorization)
        window.webkit.messageHandlers && window.webkit.messageHandlers.homeCarAuthorization && window.webkit.messageHandlers.homeCarAuthorization.postMessage({
          ClientId: 'ehi66134428600e',
          RedirectUri: redirectUri,
          State: Base64.encode(state),
          CodeChallenge: res.data,
          Scope: 'phone'
        })
      } else {
        console.log('一嗨androoid登陆方法', window.local_obj.homeCarAuthorization)
        window.local_obj && window.local_obj.homeCarAuthorization && window.local_obj.homeCarAuthorization('ehi66134428600e', redirectUri, Base64.encode(state), 'phone', res.data)
      }
    } else {
      console.log('getCodeChallenge失败')
    }
  })
}


// 通过code调用房车接口登录，promise
function loginByCode(code, state) {
  console.log('code', code)
  console.log('state', state)
  return new Promise((resolve, reject) => {
    if (!code) {
      resolve({success: false, msg: '登录失败'})
    } else {
      loginByCodeInapp({
        code: code,
        state: state
      }).then(res => {
        if (res.success) {
          resolve({success: true, url: res.data.redirectUrl || ''})
        } else {
          resolve({success: false, msg: ''})
        }
      }).catch(() => {
        resolve({success: false, msg: '登陆失败~'})
      })
    }
  })
}

export {
  loginByApp,
  loginByCode
}


// WEBPACK FOOTER //
// ./src/assets/js/oneHigh.js